'use strict'

module.exports = { version: '9.14.0' }
